module.exports = __webpack_public_path__ + "media/interestingChoice.4f913dbc.mp3";